import { render, staticRenderFns } from "./supply-popup.vue?vue&type=template&id=4138357a&scoped=true&"
import script from "./supply-popup.vue?vue&type=script&lang=js&"
export * from "./supply-popup.vue?vue&type=script&lang=js&"
import style0 from "./supply-popup.vue?vue&type=style&index=0&id=4138357a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138357a",
  null
  
)

export default component.exports